import { GET_ONE } from "../../dataFetchActions";
import { UPDATE } from "../../dataFetchActions";
import { CRUD_UPDATE } from "./crudconstants";

/** @deprecated We are phasing out legacy redux, use immi query instead */
export const crudUpdate = (resource, parentResourceId, data, params = {}) => {
  const { previousData, context, refresh = true, redirectTo, subResource, customAction, id } = params;
  return {
    type: CRUD_UPDATE,
    payload: { id: id, data, previousData },
    meta: {
      resource,
      context,
      id: parentResourceId,
      subResource,
      customAction,
      type: GET_ONE,
      fetch: UPDATE,
      onSuccess: {
        notification: {
          body: "notification.updated",
          level: "info",
          messageArgs: {
            smart_count: 1,
          },
        },
        refresh,
        redirectTo,
      },
      onFailure: {
        notification: {
          body: "notification.http_error",
          level: "warning",
        },
      },
    },
  };
};
